import { contentCartSelector, v2CartSelector, v3CartSelector } from '../constants';

export const getCartElement = (): HTMLElement => {
  // Version 2 cart item
  return document.querySelector(v2CartSelector)
    // Version 3 cart items
    || document.querySelector(v3CartSelector)
    || document.querySelector(contentCartSelector);
};
